import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { API_URL } from '../../constant';
import './CaptainTCCard.css';
import captainTcImg from '../../images/captain-tc/captain-tc-card.jpeg';

function CaptainTCCard() {
    const outletContext = useOutletContext() || {};
    const { userData } = outletContext;

    const [loading, setLoading] = useState(true);
    const [cards, setCards] = useState([
        { tier: '£5', price: '£ 5.00', purchased: false, serial: null },
        { tier: '£10', price: '£ 10.00', purchased: false, serial: null },
        { tier: '£25', price: '£25.00', purchased: false, serial: null },
    ]);

    const getAuthHeaders = useCallback(() => {
        const token = localStorage.getItem('auth_token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
    }, []);

    const fetchCardStatus = useCallback(async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('auth_token');
            if (!token) return;

            const response = await fetch(`${API_URL}/api/customer/captain-tc-cards`, {
                headers: getAuthHeaders(),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success && data.cards) {
                    setCards(prev => prev.map(card => {
                        const apiCard = data.cards.find(c =>
                            c.tier === card.tier || c.price === card.price
                        );
                        if (apiCard) {
                            return {
                                ...card,
                                purchased: apiCard.purchased || false,
                                serial: apiCard.serial || null,
                            };
                        }
                        return card;
                    }));
                }
            }
        } catch (err) {
            console.warn('Captain TC Cards API not available:', err.message);
        } finally {
            setLoading(false);
        }
    }, [getAuthHeaders]);

    useEffect(() => {
        fetchCardStatus();
    }, [fetchCardStatus]);

    if (loading) {
        return (
            <div className="captain-tc-wrapper">
                <div className="captain-tc-loading">
                    <div className="captain-tc-spinner"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="captain-tc-wrapper">
            {/* Header */}
            <div className="captain-tc-header">
                <div className="captain-tc-header-left">
                    <span className="captain-tc-label">Captain TC</span>
                    <h2 className="captain-tc-title">Cash-Wallet Card</h2>
                </div>
                {/* <div className="captain-tc-header-right">
                    <img
                        src={captainTcImg}
                        alt="Captain TC Card"
                        className="captain-tc-thumb"
                    />
                </div> */}
            </div>

            {/* Card Tiers — Separate Cards */}
            <div className="captain-tc-cards-grid">
                {cards.map((card) => (
                    <div key={card.tier} className="captain-tc-card-item">
                        {/* Owned Header */}
                        <div className="captain-tc-card-owned">
                            Owned: <span className={card.purchased ? 'owned-yes' : 'owned-no'}>
                                {card.purchased ? 'Yes' : 'No'}
                            </span>
                        </div>

                        {/* Visual Card */}
                        <div className="captain-tc-card-body">
                            <div className="captain-tc-visual-card">
                                <div className="captain-tc-visual-card-inner">
                                    <span className="captain-tc-visual-price">{card.price}</span>
                                </div>
                            </div>
                        </div>

                        {/* Serial Footer */}
                        <div className="captain-tc-card-serial">
                            {card.purchased && card.serial ? (
                                <span>Serial : <strong>{card.serial}</strong></span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CaptainTCCard;
